import img1 from "../assets/academy/academ1.jpeg";
import img2 from "../assets/academy/acad2.png";
import img3 from "../assets/academy/academ2.jpeg";
import img4 from "../assets/academy/acad4.webp";
import img5 from "../assets/academy/kombi.jpg";
import img6 from "../assets/academy/academ7.jpg";
import { title } from "framer-motion/client";

export const ACADEMY_PROGRAMS = {
  "micro-needling": {
    id: "micro-needling",
    title: "Microneedling",
    img: img1,
    price: "1290€",
    desc: {
      intro: [
        "Unsere 1:1 Microneedling Schulung in München richtet sich an Kosmetiker:innen und Beauty-Profis, die diese Behandlung individuell, sicher und auf höchstem fachlichem Niveau erlernen möchten.",
        "Die Schulung findet ausschließlich im Einzeltraining (1:1) statt und wird vollständig auf dein Wissen, dein Studio und deine Ziele abgestimmt.",
      ],
      bullets: [
        "fundierte Theorie zu Hautaufbau, Wirkstoffen, Nadeltiefen sowie Indikationen und Kontraindikationen",
        "professioneller Umgang mit Microneedling-Geräten",
        "individuelle Behandlungsprotokolle",
        "strukturierte Abläufe & sichere Nachsorge",
        "Hygienestandards & Risikominimierung",
        "individuelle Preisgestaltung für dein Studio",
      ],
      extras: [
        "● Inklusive hochwertigem Starterset",
        "● Lebenslange Nachbetreuung",
        "Nach erfolgreicher Teilnahme erhältst du ein Zertifikat.",
        "Eine Kombischulung mit Aquafacial ist möglich.",
      ],
    },
  },
  "lash-browlifting": {
    id: "lash-browlifting",
    title: "Lash & Browlifting",
    desc: "Meistern Sie die Architektur des Gesichts durch unseren dualen Spezialisierungskurs für Lifting-Techniken. Dieses Programm vermittelt Ihnen die präzise Wissenschaft der chemischen Umstrukturierung, damit Sie Haare liften und fixieren können, ohne deren Struktur zu gefährden. Wir behandeln individuelles Mapping der Augenform, die chemische Zusammensetzung von Fixierlotionen und fortgeschrittene Mischverhältnisse für Tönungen. Über die Technik hinaus erlernen Sie die Kunst der „Brow Lamination“, um den gefragten Editorial-Look zu kreieren und Ihren Kunden eine pflegeleichte, effektvolle Alternative zu Extensions zu bieten.",
    price: "349 €",
    duration: "1 Tag",
    img: img2,
  },
  aquafacial: {
    id: "aquafacial",
    title: "Aquafacial",
    desc: {
      intro: [
        "Die 1:1 Aquafacial Schulung in München ist ideal für Beauty-Profis, die eine moderne apparative Behandlung persönlich, praxisnah und effizient erlernen möchten.",
        "Im Einzeltraining gehen wir gezielt auf deine Vorkenntnisse ein und passen die Schulung an dein Studio, deine Zielgruppe und deine Behandlungsziele an. Der Fokus liegt auf einer direkten Umsetzung in die Praxis.",
      ],
      bullets: [
        "Gerätekunde & Funktionsweise",
        "strukturierter Behandlungsablauf von der Hautanalyse bis zur Abschlusspflege",
        "Wirkstoffe & Seren gezielt einsetzen",
        "Hygiene, Sicherheit & Kontraindikationen",
        "Kombinationsmöglichkeiten mit Microneedling",
        "Kalkulation & Vermarktung der Behandlung",
      ],
      extras: [
        "● Inklusive hochwertigem Starterset",
        "Du erhältst ein exklusives Starterset von Nu Skin und Cure Concept, abgestimmt auf die Aquafacial-Behandlung.",
        "● Lebenslange Nachbetreuung",
        "Auch nach der Schulung stehen wir dir mit einer lebenslangen Nachbetreuung zur Seite – persönlich, kompetent und zuverlässig.",
        "Nach Abschluss erhältst du ein Zertifikat.",
        "Eine Kombischulung mit Microneedling ist möglich.",
      ],
    },
    price: "1190€",
    duration: "1 Tag",
    img: img3,
  },

  "eye-lash-extension": {
    id: "eye-lash-extension",
    title: "Wimpernverlängerung",
    desc: "Unsere Ausbildung für Wimpernverlängerung ist für all jene konzipiert, die absolute Präzision in der luxuriösen Wimpernkunst anstreben. Dieses hochkarätige Training geht über die einfache Applikation hinaus und vertieft sich in fortgeschrittenes Lash-Mapping, Gewichtsverteilung und Klebstoffchemie. Sie werden in der klassischen Einzelwimpern-Methode sowie in Hybrid- und russischen Volumentechniken geschult. Dabei lernen Sie, wie man maßgeschneiderte Fächer erstellt, die die Gesundheit der Naturwimpern respektieren. Der Kurs umfasst ein essenzielles Modul zur Augenanatomie, Kontraindikationen und zur wirtschaftlichen Führung eines exklusiven Lash-Business.",
    price: "349 €",
    duration: "3 Tage",
    img: img4,
  },
  dermaplanning: {
    id: "kombischulung",
    title: "Kombischulung",
    desc: {
      intro: [
        "Unsere exklusive 1:1 Kombi-Schulung Aquafacial & Microneedling bietet den höchsten Mehrwert für dein Studio.",
        "Beide Behandlungen werden intensiv geschult und sinnvoll miteinander kombiniert.",
      ],
      bullets: [
        "1:1 Einzeltraining",
        "hochwertige Startersets von Nu Skin & Cure Concept",
        "individuelle Behandlungsprotokolle",
        "zwei Zertifikate",
        "lebenslange Nachbetreuung",
      ],
      extras: [],
    },
    price: "2290€",
    duration: "1 Tag",
    img: img5,
  },
  "mediostar-laser": {
    id: "mediostar-laser",
    title: "Mediostar Laser",
    desc: {
      intro: [
        "Unsere Mediostar Laser Schulung richtet sich an qualifizierte Anwender:innen, die ihre Fachkenntnisse im Bereich der apparativen Ästhetik auf höchstem Niveau erweitern möchten.",
        "Die Schulung wird individuell auf Anfrage angeboten und richtet sich nach deinem Kenntnisstand, deinem Arbeitsumfeld sowie den gewünschten Behandlungsbereichen. Ziel ist es, dir einen sicheren, verantwortungsvollen und professionellen Umgang mit dem Mediostar Laser zu vermitteln.",
      ],
      bullets: [
        "Grundlagen der Laserphysik",
        "Gerätekunde Mediostar",
        "Indikationen & Kontraindikationen",
        "Behandlungsparameter & Sicherheit",
        "Haut- und Haaranalyse",
        "Behandlungsabläufe & Nachsorge",
        "Hygienestandards & rechtliche Grundlagen",
      ],
      extras: [
        "Die Schulung findet in einem exklusiven Rahmen statt und bietet ausreichend Raum für persönliche Betreuung, praxisnahe Inhalte und individuelle Fragestellungen.",
        "● Persönliche Nachbetreuung",
        "Auch nach der Schulung stehen wir dir für fachliche Rückfragen und praktische Unterstützung zur Verfügung.",
        "● Schulung auf Anfrage",
        "Da diese Schulung individuell geplant wird, erfolgt die Buchung ausschließlich auf Anfrage. Gerne besprechen wir Inhalte, Ablauf und Voraussetzungen persönlich.",
      ],
    },
    price: "Auf Anfrage",
    // duration: "Individuell",
    img: img6, // change if needed
  },
};
